module.exports = __webpack_public_path__ + "media/images/icon_photo_white-3068ef29644712f1fc76f11827050abe.png";